module.exports = __webpack_public_path__ + "images/emoji/white_large_square.8f4e490b23c5d40f613b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/white_large_square.png
// module id = 4/4W
// module chunks = 13